import { render, staticRenderFns } from "./BeSwitcher.vue?vue&type=template&id=0ee29074&scoped=true"
import script from "./BeSwitcher.vue?vue&type=script&lang=js"
export * from "./BeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BeSwitcher.vue?vue&type=style&index=0&id=0ee29074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee29074",
  null
  
)

export default component.exports